import styled from 'styled-components';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { pipe } from 'fp-ts/function';
import { TextKey, DataTestId, RouteName } from '@mews-commander/enums';
import { IconName, Stack } from '@optimus-web/core';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { canCurrentProfileManageRates } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import DashboardTitle from '../../dashboard/components/DashboardTitle';
import DashboardTextLink from '../../dashboard/components/DashboardTextLink';

const OccupancyReportWidgetHeader = ({ enterpriseId, serviceId, canManageRates }: $TSFixMe) => (
    <>
        <InlineDashboardTitle testId={DataTestId.Occupancy} textKey={TextKey.Occupancy} />
        <Stack spacing="100" inline wrap>
            <DashboardTextLink
                textKey={TextKey.AvailabilityOccupancyReport}
                iconName={IconName.Availability}
                route={RouteName.AvailabilityReportIndex}
                routeParams={{
                    query: {
                        PartialBind: true,
                        ScopeId: enterpriseId,
                        'Services.Id[]': serviceId,
                    },
                }}
            />
            <DashboardTextLink
                textKey={TextKey.AvailabilityBlockReport}
                iconName={IconName.Website}
                route={RouteName.AvailabilityBlockReportIndex}
                routeParams={{
                    query: {
                        serviceId,
                    },
                }}
            />
            {canManageRates && serviceId && (
                <DashboardTextLink
                    textKey={TextKey.RateManagement}
                    iconName={IconName.RateManagement}
                    route={RouteName.VisitDefaultPricing}
                    routeParams={{
                        serviceId,
                    }}
                />
            )}
        </Stack>
    </>
);

export default pipe(
    OccupancyReportWidgetHeader,
    connect(
        createStructuredSelector({
            enterpriseId: getCurrentEnterpriseId,
            serviceId: getSelectedServiceId,
            canManageRates: canCurrentProfileManageRates,
        })
    )
);

const InlineDashboardTitle = styled(DashboardTitle)`
    display: inline-block;
`;
